<div class="private-content-informer">
  <app-icon
    icon="lock"
    class="lock-icon"
    [width]="35"
    [height]="35">
  </app-icon>
  <h2 class="title">{{ 'collections.private-content-informer.title' | translate }}</h2>
  <p class="text"
     *ngIf="collections && collections?.length > 0">{{ 'collections.private-content-informer.message' | translate }}</p>

  <div class="collection-list" *ngIf="collections && collections?.length > 0">
    <div class="title">{{ 'collections.private-content-informer.incollection' | translate }}</div>
    <ng-template [ngIf]="isDragScrollEnabled" [ngIfElse]="responsiveScroll">
    <div class="carousel no-overflow">
      <ng-template [ngIf]="collections.length >= 3">
        <div class="right-btn" (click)="moveRight()">
          <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
        </div>

        <div class="left-btn" (click)="moveLeft()">
          <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
        </div>
      </ng-template>
      <div class="carousel">
        <cdk-virtual-scroll-viewport #scroller [itemSize]="itemSize" class="scroll-viewport" orientation="horizontal">
          <div *cdkVirtualFor="let collection of collections; let i = index; trackBy: trackContentByFn"
               class="scroll-item">
            <app-collection-card-mini [displayMode]="'lesson-collection'"
                                      [collection]="collection"></app-collection-card-mini>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    </ng-template>

    <ng-template #responsiveScroll>
      <div class="responsive-scroll-viewport">
        <div *ngFor="let collection of collections; let i = index; trackBy: trackContentByFn"
             class="scroll-item">
          <app-collection-card-mini [displayMode]="'lesson-collection'"
                                    [collection]="collection"></app-collection-card-mini>
        </div>
      </div>
    </ng-template>
  </div>
</div>
